import GlobalStore from "@ipru-common/store/GlobalStore";
import { convertToISODate, readQueryParams, getSelectedFunds } from "@ipru-common/utils/CommonFunctions";
import { OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";
import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { mapDataToSuitabilityData } from "@ipru-common/components/CommonComponents/SuitabilityCalModal/SuitabilityMapper";
import { getAge } from "@ipru-common/libs/ValidationSchemas/CustomRules";
import { getCurrentTimeStamp, getWOPOption, trueFalse, yesNo } from "../SavingsAppForm/SavingAppFormsUtils";
import { PRODUCT_NAMES } from "@ipru-common/constants/products";

const getcg2NetCoreInput = () => {
  const { quoteFormData, calculatorFormData, appFormData, savingForm, existingCustomer, currentPageStep } =
    GlobalStore.getSnapshot();
  const suitabilityData = mapDataToSuitabilityData(calculatorFormData, quoteFormData);

  const { familyIncomePercent } = quoteFormData;
  const selectedfunds = quoteFormData?.allocatedFunds ? getSelectedFunds(quoteFormData?.allocatedFunds) : 0;
  const { personalDetails } = appFormData;
  const RiderOptionAdded =
    !!quoteFormData?.selectedRiders?.length > 0 ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING;
  const queryParams = readQueryParams();
  const { isWopSelected, wopOption } = getWOPOption(quoteFormData?.selectedRiders);
  const UID = queryParams.get("UID") || "480";
  let selectedfundList = quoteFormData?.allocatedFunds
    ?.filter((item) => item?.value > 0)
    ?.map((item) => `${item?.Fund} - ${item?.value}`);

  function getOnlineReturnByRate(rate) {
    //Function to extract the online returns from quoteFormData
    const items = quoteFormData?.calculatedData?.returns?.arr || [];
    const match = items.find((item) => item.rateOfInterest === rate);
    return match?.onlineReturn || null;
  }

  let cg2Input = {
    age: calculatorFormData?.age,
    dob: convertToISODate(calculatorFormData?.user_dob),
    gender: calculatorFormData?.gender,
    usetobacco: calculatorFormData?.tobacco,
    term: quoteFormData?.term,
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    sumassured: quoteFormData?.lifeCover,
    payoutoptions: LMS_CONSTANTS[quoteFormData?.payoutType],
    paymentfrequency: quoteFormData?.paymentFrequency,
    firstname: "",
    lastname: "",
    mobileno: calculatorFormData?.mobileno,
    emailid: calculatorFormData?.emailid,
    address: personalDetails?.full_address,
    pincode: calculatorFormData?.pincode,
    premium: quoteFormData?.invest + +quoteFormData?.riderPremium,
    occupation: calculatorFormData?.calc_occupation,
    nominee: personalDetails?.nominee_fullname,
    trai: calculatorFormData?.trai_flag,
    paymentoption: LMS_CONSTANTS[quoteFormData?.paymentOption],
    relation: suitabilityData?.relation,
    mode: suitabilityData?.mode,
    ppt: quoteFormData?.ppt,
    lifecover: quoteFormData?.lifeCover,
    productid: calculatorFormData?.productCode,
    invest_type: suitabilityData?.invest_type,
    uid: UID,
    annualincome: parseInt(calculatorFormData?.yr_income),
    step: `step${savingForm?.currentStep}`,
    adbr: suitabilityData?.adbr,
    payout: LMS_CONSTANTS[quoteFormData?.payoutType] ?? "LumpSum",
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    invest_strat: suitabilityData?.invest_strat,
    fundcat: "", //suitabilityData?.fundCat
    page_title: PRODUCT_NAMES.GIFT_CITY,
    modalpremium: quoteFormData?.invest,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    name: personalDetails?.full_name,
    selectoption_dropdown: 0,
    investvalue: quoteFormData?.invest,
    traiflag: yesNo(calculatorFormData?.trai_flag),
    appformdetails: "",
    communication: "",
    health: "",
    payoutdetails: "",
    proposerdetails: "",
    proposercommunication: "",
    sourceurl: window.location.href,
    existingcustomer: yesNo(existingCustomer?.clientId),
    stay_details: "",
    proposer_stay_details: "",
    p_gender: calculatorFormData?.propGender,
    p_dob: calculatorFormData?.propAge,
    p_age: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    rideroptionadded: RiderOptionAdded,
    rider1: quoteFormData?.selectedRiders?.[0]?.sectionName,
    rider2: quoteFormData?.selectedRiders?.[1]?.sectionName,
    rider3: quoteFormData?.selectedRiders?.[2]?.sectionName,
    wop_selctedoption: wopOption,
    education: calculatorFormData?.calc_education,
    iswhatsappopted: yesNo(quoteFormData?.wth_option),
    isnri: trueFalse(calculatorFormData.nri) ? OPTION_VALUES.TRUE_STRING : OPTION_VALUES.FALSE_STRING,
    lms_nri: calculatorFormData?.nri,
    health_la: "",
    health_pa: "",
    iswop: yesNo(isWopSelected),
    propage: calculatorFormData?.propAge ? getAge(calculatorFormData?.propAge) : "",
    propdob: calculatorFormData?.propAge ?? "",
    propgender: calculatorFormData?.propGender,
    city: calculatorFormData?.city,
    p_ender: calculatorFormData?.propGender,
    suitcheckbox: "TRUE",
    qdata: queryParams?.get("qdata") ?? "",
    deathbenefitoption: "",
    brochure_selected: "",
    tollfree_selected: "",
    isandroid: new URL(window.location.href).searchParams.get("device") === "android",
    isios: new URL(window.location.href).searchParams.get("device") === "ios",
    maritalstatus: personalDetails?.marital_status,
    pagename: PRODUCT_NAMES.GIFT_CITY,
    appno: appFormData?.appNO,
    selectedfunds: "",
    productselection: "",
    kycwaveoff: "",
    suitabilitymatrix: "", // suitabilityMatrix,
    emailaddress: calculatorFormData?.emailid,
    pan_validation_status: "",
    ekycdetails: "",
    familyincome: familyIncomePercent,
    currentpagestep: currentPageStep,
    isenglish: "TRUE",
    trai_flag: yesNo(calculatorFormData?.trai_flag),
    savingspercentage: suitabilityData?.pastPerformancePercent,
    lifecovernew: "",
    internationalmobileno: calculatorFormData?.mobileno,
    nrimoblieno: calculatorFormData?.mobileno,
    adbterm: "",
    accidental_death_benefit: "",
    nriarrivingdate: appFormData?.personalDetails?.nri_arriving_date,
    state: calculatorFormData?.state,
    lduid: UID,
    qdata_pasa: false,
    outputobjhold_4: getOnlineReturnByRate(4),
    outputobjhold_8: getOnlineReturnByRate(8),
    fund_name: selectedfunds?.length > 0 ? selectedfunds[0]?.Fund : (quoteFormData?.selectedFund ?? ""),
    funds_selected: selectedfundList?.join(", "),
    countrycode: calculatorFormData?.country_code,
    samultiple: quoteFormData?.saMultiple ?? "NA",
    customer_name: appFormData?.full_name,
    wop_upto: quoteFormData?.premiumWaiver,
    isdefaultpastrequired: true,
    portfolio_strategy: quoteFormData?.portfolio_strategy || "",
    pri_medical_data: "",
    storycode: "",
    timestamp: getCurrentTimeStamp(),
    variant_name: "",
    whole_life: suitabilityData?.whole_life,
  };

  return cg2Input;
};

export default getcg2NetCoreInput;
